import axios from '../../axios'

/*
 * 考试数据接口
 */

// 获取考试列表
export const getExamList = (data) => {
    return axios({
        url: '/api/mock/base/exam',
        method: 'get',
        data
    })
}

export const getExam = (data) => {
    return axios({
        url: '/api/mock/base/exam_info',
        method: 'get',
        data
    })
}

// 跟进省份ID获取考试列表
export const getExamByProvince = (data) => {
    return axios({
        url: '/api/mock/base/exam_area',
        method: 'get',
        data
    })
}

export const getAreaAgent = (data) => {
    return axios({
        url: '/api/mock/base/area_agent',
        method: 'get',
        data
    })
}

// 新增考试信息
export const saveExam = (data) => {
    return axios({
        url: '/api/mock/base/exam',
        method: 'post',
        data
    })
}

// 编辑考试信息
export const updateExam = (data) => {
    return axios({
        url: '/api/mock/base/exam',
        method: 'put',
        data
    })
}

// 删除考试列表
export const deleteExam = (data) => {
    return axios({
        url: '/api/mock/base/exam',
        method: 'delete',
        data
    })
}
// 获取考区
export const getAreaAgentByExamId = (data) => {
    return axios({
        url: '/api/mock/base/exam_area_agent',
        method: 'get',
        data
    })
}

// 获取机构根据考试id
export const getAgentByExamId = (data) => {
    return axios({
        url: '/api/mock/base/exam_agent',
        method: 'get',
        data
    })
}

// 导出机构信息
export const exportExamAreaAgent = (data) => {
    return axios({
        url: '/api/mock/base/exam/area/agent/export',
        method: 'POST',
        data
    })
}

// 导入机构信息
export const importExamAreaAgent = (data) => {
    return axios({
        url: '/api/mock/base/exam/area/agent/import',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/base/exam.js